import { render, staticRenderFns } from "./SignList.vue?vue&type=template&id=1b55f9a3"
import script from "./SignList.vue?vue&type=script&lang=ts"
export * from "./SignList.vue?vue&type=script&lang=ts"
import style0 from "./SignList.vue?vue&type=style&index=0&id=1b55f9a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports